import React from "react";
import { withRouter } from "react-router-dom";
import CONSTANT from "./../../../constant";
import Loader from "./../../../component/common/Loader";
import { getAssignedEmployees } from "./../../../actions/AppraisalCycleAction";
import { formatDateDDMMYY } from "./../../../utils";

class ReviewingManagerReport extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      list: undefined,
      showLoader: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Reviewing Manager - Assigned Employees - " + CONSTANT.organisation.name;
    this.loadList();
  }

  loadList = () => {
    this.setState({ showLoader: true });
    getAssignedEmployees({ roleType: "reviewing" }).then((res: any) => {
      const list = res?.result || res || [];
      this.setState({ list, showLoader: false });
    });
  };

  navigateToKpiApproval = (employee: any) => {
    this.props.history.push({
      pathname: CONSTANT.component.kpiApprovalReviewing.url,
      state: {
        role: 'reviewing',
        employeeCode: employee.employeeCode,
        employeeName: employee.employeeName,
        employeeNumber: employee.employeeNumber,
        effectiveFrom: employee.effectiveFrom,
        effectiveTo: employee.effectiveTo,
        ...this.buildManagerState(employee),
      },
    });
  };

  navigateToReport = (employee: any) => {
    this.props.history.push({
      pathname: CONSTANT.component.aparReviewingManagerForm1.url,
      state: {
        employeeCode: employee.employeeCode,
        employeeName: employee.employeeName,
        employeeNumber: employee.employeeNumber,
        effectiveFrom: employee.effectiveFrom,
        effectiveTo: employee.effectiveTo,
        kpiReportId: employee.kpiReportId || employee.kpi_report_id,
        ...this.buildManagerState(employee),
      },
    });
  };

  navigateToFullDetail = (employee: any) => {
    this.props.history.push({
      pathname: CONSTANT.component.aparEmployeeFullDetailView.url,
      state: {
        viewerRole: "reviewing",
        employeeCode: employee.employeeCode,
        employeeName: employee.employeeName,
        employeeNumber: employee.employeeNumber,
        effectiveFrom: employee.effectiveFrom,
        effectiveTo: employee.effectiveTo,
        kpiReportId: employee.kpiReportId || employee.kpi_report_id,
        ...this.buildManagerState(employee),
      },
    });
  };

  buildManagerState = (employee: any) => ({
    reportingManagerCode: employee.reportingManagerCode,
    reportingManagerName: employee.reportingManagerName,
    reportingManagerNumber: employee.reportingManagerNumber,
    reviewingManagerCode: employee.reviewingManagerCode,
    reviewingManagerName: employee.reviewingManagerName,
    reviewingManagerNumber: employee.reviewingManagerNumber,
    acceptingAuthorityCode: employee.acceptingAuthorityCode,
    acceptingAuthorityName: employee.acceptingAuthorityName,
    acceptingAuthorityNumber: employee.acceptingAuthorityNumber,
  });

  getKpiStatusBadge = (status: string) => {
    const map: any = {
      draft: { cls: 'badge-secondary', label: 'Draft' },
      submitted: { cls: 'badge-secondary', label: 'Pending RM Approval' },
      rm_approved: { cls: 'badge-warning', label: 'Pending Your Approval' },
      rvm_approved: { cls: 'badge-success', label: 'Approved by You' },
      sent_back_by_rm: { cls: 'badge-secondary', label: 'Sent Back to Employee by RM' },
      sent_back_by_rvm: { cls: 'badge-danger', label: 'Sent Back by You' },
    };
    const info = map[status] || { cls: 'badge-secondary', label: status || 'Not Started' };
    return <span className={`badge ${info.cls}`}>{info.label}</span>;
  };

  render() {
    const { list, showLoader } = this.state;

    return (
      <div className="container-fluid mb-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card homedob">
              <div className="row">
                <div className="col-md-12">
                  <h1 className="page-title">
                    <i className="fa fa-users text-warning mr-2" />
                    Reviewing Manager - Assigned Employees
                  </h1>
                  <p className="text-muted">Employees assigned to you as Reviewing Manager in the active appraisal cycle.</p>
                </div>
              </div>

              {showLoader && <Loader />}

              <div className="row mt-3">
                <div className="col-md-12">
                  <div className="table-container">
                    <div className="table-wrapper radius-4">
                      <table className="tablen">
                        <thead>
                          <tr className="text-center">
                            <th className="table-dark">#</th>
                            <th className="table-dark">Employee #</th>
                            <th className="table-dark">Name</th>
                            <th className="table-dark">Reporting Manager</th>
                            <th className="table-dark">Reviewing Manager</th>
                            <th className="table-dark">Accepting Authority</th>
                            <th className="table-dark">Effective From</th>
                            <th className="table-dark">Effective To</th>
                            <th className="table-dark">KPI Status</th>
                            <th className="table-dark">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {list === undefined && (
                            <tr>
                              <td colSpan={10} className="text-center">Loading...</td>
                            </tr>
                          )}
                          {list !== undefined && list.length === 0 && (
                            <tr>
                              <td colSpan={10} className="text-center">No employees assigned to you.</td>
                            </tr>
                          )}
                          {list !== undefined && list.map((item: any, index: number) => {
                            const kpiStatus = item.kpiStatus || item.kpi_status || null;
                            const achievementsFilled = item.achievementsFilled || item.achievements_filled || false;
                            const canReviewKpi = kpiStatus === 'rm_approved';
                            const rmReportFilled = item.rmReportFilled || item.rm_report_filled || false;
                            const canFillReport = kpiStatus === 'rvm_approved' && achievementsFilled && rmReportFilled;

                            let fillReportTooltip = '';
                            if (!canFillReport) {
                              if (kpiStatus !== 'rvm_approved') fillReportTooltip = 'KPI must be fully approved first';
                              else if (!achievementsFilled) fillReportTooltip = 'Waiting for employee to fill achievements';
                              else if (!rmReportFilled) fillReportTooltip = 'Reporting Manager has not submitted their report yet';
                            }

                            return (
                              <tr key={item.authorityId || index} className="text-center">
                                <td>{index + 1}</td>
                                <td>{item.employeeNumber}</td>
                                <td>{item.employeeName}</td>
                                <td>{item.reportingManagerName || '-'}</td>
                                <td>{item.reviewingManagerName || '-'}</td>
                                <td>{item.acceptingAuthorityName || '-'}</td>
                                <td>{item.effectiveFrom ? formatDateDDMMYY(item.effectiveFrom) : '-'}</td>
                                <td>{item.effectiveTo ? formatDateDDMMYY(item.effectiveTo) : 'Present'}</td>
                                <td>{this.getKpiStatusBadge(kpiStatus)}</td>
                                <td>
                                  <div className="d-flex justify-content-center gap-2">
                                    {(canReviewKpi || kpiStatus === 'rvm_approved' || kpiStatus === 'sent_back_by_rvm') && (
                                      <button
                                        className={`btn btn-sm ${canReviewKpi ? 'btn-warning' : 'btn-outline-info'}`}
                                        onClick={() => this.navigateToKpiApproval(item)}
                                      >
                                        <i className={`fa ${canReviewKpi ? 'fa-check-circle' : 'fa-eye'} mr-1`} />
                                        {canReviewKpi ? 'Review KPI' : 'View KPI'}
                                      </button>
                                    )}
                                    <button
                                      className="btn btn-sm btn-outline-secondary"
                                      onClick={() => this.navigateToFullDetail(item)}
                                      title="View employee self-appraisal + Reporting Manager's assessment"
                                      style={{ visibility: rmReportFilled ? 'visible' : 'hidden' }}
                                    >
                                      <i className="fa fa-file-text-o mr-1" />
                                      View Details
                                    </button>
                                    <button
                                      className="btn btn-sm submit-button"
                                      onClick={() => this.navigateToReport(item)}
                                      disabled={!canFillReport}
                                      title={fillReportTooltip}
                                    >
                                      <i className={`fa ${item.rvmReportSubmitted ? 'fa-check' : 'fa-pencil'} mr-1`} />
                                      {item.rvmReportSubmitted ? 'Submitted' : 'Fill Report'}
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ReviewingManagerReport);
